import { MappedResult } from '../mapped/index.mjs';
import { Partial } from './partial.mjs';
// prettier-ignore
function FromProperties(K, options) {
    return globalThis.Object.getOwnPropertyNames(K).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Partial(K[K2], options) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, options) {
    return FromProperties(R.properties, options);
}
// prettier-ignore
export function PartialFromMappedResult(R, options) {
    const P = FromMappedResult(R, options);
    return MappedResult(P);
}
